import Button from "react-bootstrap/Button";
import styles from "./acuant-camera-capture-button-container.less";

type AcuantCameraCaptureButtonContainerProps = {
    onClickCaptureButton: () => void;
};

export const AcuantCameraCaptureButtonContainer = (props: AcuantCameraCaptureButtonContainerProps) => {
    const { onClickCaptureButton } = props;

    return (
        <div className={styles.acuantCameraCaptureButtonContainer}>
            <Button className={styles.captureButton} onClick={onClickCaptureButton} />
        </div>
    );
};